import { handleActions } from 'redux-actions'
import {
  REQUEST_TEST_SOURCE_SETTINGS,
  REQUEST_TEST_SOURCE_SETTINGS_ERROR,
  RECEIVED_TEST_SOURCE_SETTINGS,
  CLEAR_TEST_SOURCE_SETTINGS
} from '../actions'

const initialState = {
  isRequesting: false,
  didRequestFail: false,
  hasRequested: false,
  data: []
}

export default handleActions({
  [REQUEST_TEST_SOURCE_SETTINGS] () {
    return {
      ...initialState,
      isRequesting: true,
      hasRequested: true
    }
  },
  [REQUEST_TEST_SOURCE_SETTINGS_ERROR] (state) {
    return {
      ...state,
      isRequesting: false,
      didRequestFail: true,
      data: [{
        reason: 'internal',
        level: 'critical'
      }]
    }
  },
  [RECEIVED_TEST_SOURCE_SETTINGS] (state, { payload }) {
    const { response } = payload
    return {
      ...state,
      isRequesting: false,
      data: response.errors
    }
  },
  [CLEAR_TEST_SOURCE_SETTINGS] () {
    return initialState
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/source-settings-validation.js